import { Injectable } from '@angular/core';
import { HttpServices } from 'src/app/shared/services/http-service.service';
import { RepairRequestDTO } from '../models/RepairRequestDTO.model';
import { HttpClient } from '@angular/common/http';
import { AdminResponseDto } from '../models/adminResponseDto';

@Injectable({
  providedIn: 'root'
})
export class RepairRequestService {

  constructor(private http: HttpServices,private httpClient: HttpClient) { }

  getRepairRequest(requestId){
    return this.http.get('RepairRequest/GetRepairRequest/'+requestId);
  }

  addRepairRequest(repairRequest: RepairRequestDTO) {

    return this.http.post('RepairRequest/AddRepairRequest', repairRequest);
  }
  public adminReviewRequest (adminResponseDto:AdminResponseDto ) {
    return this.http.post('RepairRequest/AdminReviewRequest',adminResponseDto);
  }
}
